import { baseBackend } from "../../../../api/base/baseUrl";

const RATES_CITY_URL = "/api/v2/rates/city";

export async function getRatesCityListRequest() {
  const response = await baseBackend.get(RATES_CITY_URL);
  return response.data;
}

export async function getRatesCityByIdRequest(id) {
  const response = await baseBackend.get(`${RATES_CITY_URL}/id/${id}`);
  return response.data;
}

export async function createRatesCityRequest(payload) {
  const response = await baseBackend.post(RATES_CITY_URL, payload);
  return response.data;
}

export async function updateRatesCityRequest(payload) {
  const response = await baseBackend.put(RATES_CITY_URL, payload);
  return response.data;
}

export async function deleteRatesCityRequest(id) {
  const response = await baseBackend.delete(`${RATES_CITY_URL}/id/${id}`);
  return response.data;
}
